import React from "react";
import { Route, Routes } from "react-router-dom";
import "./AuthLayout.scss";
import logoImg from "../../assests/img/logo.png";
import LoginPage from "../../pages/LoginPage/LoginPage";
import ForgotPassword from "../../pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../../pages/ResetPassword/ResetPassword";
import NewUserRegistration from "../../pages/NewUserRegistration/NewUserRegistration";
import copyrightLogo from "../../assests/img/footerimg.png";

const AuthLayout = () => {
  return (
    <div
      className="auth-layout-container"
      style={{ display: "flex", flexDirection: "column", minHeight: "100dvh", overflow:'auto' }}
    >
      <div className="container-fluid" style={{ flex: "1", display:'flex', justifyContent:'center', alignItems:'center',flexDirection:'column' }}>
        <div className="row">
          <div className="col-md-12 text-center mb-3">
            <img
              src={logoImg}
              alt="logo"
              style={{
                height: "175px",
                width: "132px",
              }}
            />
          </div>
        </div>
        <div className="row testing">
          <div
            className="col-md-12 text-center text-white mb-4"
            style={{
              // marginBottom: "28px",
            }}
          >
            <p
              className="mb-0"
              style={{
                fontSize: "24px",
                fontFamily: "Helvetica-Light",
                whiteSpace: "nowrap" /* Prevents line breaks */,
              }}
            >
              INTELLIGENT WATER MANAGEMENT
            </p>
          </div>
          <style>
            {`
          @media (max-width: 475px) {
            .col-md-12 p {
              font-size: 18px !important;
              white-space: noWrap !important;
              
            }
          }
        `}
          </style>
        </div>
        <>
          {/* <Router> */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-sm-8 col-md-6 col-lg-4">
                <Routes>
                  <Route path="/" element={<LoginPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/forgotpassword" element={<ForgotPassword />} />
                  <Route path="/resetpassword" element={<ResetPassword />} />
                  <Route path="/newuserregistration" element={<NewUserRegistration />} />
                </Routes>
              </div>
            </div>
          </div>
          {/* </Router> */}
        </>
      </div>
      {/* Footer Section */}
      <footer
        style={{
          paddingBottom: "17px",
          paddingTop: "17px",
          textAlign: "center",
          bottom:'0px',
          marginTop:'auto'
        }}
      >
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',

        }} className="container-fluid ">
          <img
            className="footer-logo"
            style={{
              width: "360px",
            }}
            src={copyrightLogo}
            alt=""
          />
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout;
